import React, { useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useTranslate } from 'react-polyglot';

const Faq = () => {
  const t = useTranslate(); // Initialize translation function
  const [activeIndex, setActiveIndex] = useState();

  const faqItems = [
    {
      header: t('what_is_zkcandy'),
      content: t('what_is_zkcandy_desc')
    },
    {
      header: t('what_is_passport'),
      content: t('what_is_passport_desc')
    },
    {
      header: t('where_campaigns'),
      content: t('where_campaigns_desc')
    },
    {
      header: t('live_now'),
      content: t('live_now_desc')
    },
    {
      header: t('cost'),
      content: t('cost_desc')
    },
    {
      header: t('wallets'),
      content: t('wallets_desc')
    },
    {
      header: t('only_layer3'),
      content: t('only_layer3_desc')
    }
  ];

  return (
    <div id="faq" className={`portal-header-frame type-1`}>
      <div className="portal-frame">
        <div className="title text-center mb-4">{t('faqs')}</div>
        <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          {faqItems.map((item, index) => (
            <AccordionTab key={index} header={item.header}>
              <p className="m-0 font-montserrat" dangerouslySetInnerHTML={{ __html: item.content }}></p>
            </AccordionTab>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default Faq;